import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { PlayButtonIcon } from 'src/svg/PlayButtonIcon';

interface AuthenticatedControlsProps {
  hasDemo?: boolean;
  handlePlay: () => void;
  handleNavigateToDemoGame: () => void;
}

export const AuthenticatedControls = ({
  hasDemo,
  handlePlay,
  handleNavigateToDemoGame
}: AuthenticatedControlsProps) => {
  const { t } = useTranslation();
  return (
    <>
      {!hasDemo ? (
        <PlayButtonIcon onClick={handlePlay} />
      ) : (
        <Button
          onClick={handlePlay}
          title={t('general.play') as string}
          mode="button-primary"
          className="w-full h-8 text-xs !py-2">
          {t('general.play')}
        </Button>
      )}

      {hasDemo && (
        <>
          <p className="text-xs text-gc_name_game my-1">{t('general.or')}</p>
          <Button
            mode="button-secondary"
            className="text-xs h-8"
            onClick={handleNavigateToDemoGame}
            title={t('general.demo') as string}
            label={t('general.demo') as string}
          />
        </>
      )}
    </>
  );
};
